import { render, staticRenderFns } from "./VFatherProAnamCAxASC.vue?vue&type=template&id=570369e9"
import script from "./VFatherProAnamCAxASC.vue?vue&type=script&lang=js"
export * from "./VFatherProAnamCAxASC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports